import SessionPreview from './session-preview.component'

export default SessionPreview
